import * as types from './actionTypes';

const initialState = {
  referralsList: null,
  referralsListLoading: false,
  addReferralLoading: false,
  addReferralSuccess: false,
  referralDetails: null,
  referralDetailsLoading: false,
  updateReferralStatusLoading: false,
  referralStatusUpdateSuccess: false,
};

export const referralsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_REFERRALS_LIST:
      return {
        ...state,
        referralsListLoading: true,
      };
    case types.SET_REFERRALS_LIST:
      return {
        ...state,
        referralsList: payload,
        referralsListLoading: false,
      };
    case types.SET_REFERRALS_LIST_FAILED:
      return {
        ...state,
        referralsListLoading: false,
      };
    case types.ADD_REFERRAL:
      return {
        ...state,
        addReferralLoading: true,
      };
    case types.ADD_REFERRAL_SUCCESS:
      return {
        ...state,
        addReferralLoading: false,
        addReferralSuccess: true,
      };
    case types.ADD_REFERRAL_FAILED:
      return {
        ...state,
        addReferralLoading: false,
      };
    case types.CLEAR_ADD_REFERRAL_SUCCESS:
      return {
        ...state,
        addReferralSuccess: false,
      };
    case types.GET_REFERRAL_DETAILS:
      return {
        ...state,
        referralDetailsLoading: true,
        referralDetails: null,
      };
    case types.SET_REFERRAL_DETAILS:
      return {
        ...state,
        referralDetails: payload,
        referralDetailsLoading: false,
      };
    case types.SET_REFERRAL_DETAILS_FAILED:
      return {
        ...state,
        referralDetailsLoading: false,
      };
    case types.CLEAR_REFERRAL_DETAILS:
      return {
        ...state,
        referralDetails: null,
      };
    case types.UPDATE_REFERRAL_STATUS:
      return {
        ...state,
        updateReferralStatusLoading: true,
        referralStatusUpdateSuccess: false,
      };
    case types.UPDATE_REFERRAL_STATUS_SUCCESS:
      return {
        ...state,
        updateReferralStatusLoading: false,
        referralStatusUpdateSuccess: true,
      };
    case types.UPDATE_REFERRAL_STATUS_FAILED:
      return {
        ...state,
        updateReferralStatusLoading: false,
        referralStatusUpdateSuccess: false,
      };
    case types.CLEAR_REFERRAL_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        referralStatusUpdateSuccess: false,
      };
    default:
      return state;
  }
};
